export function format(fmt, km, escape) {
    var _a, _b;
    const escapeReplacement = escape + escape;
    const rest = [];
    const fmtLen = fmt.length;
    const fmtChars = Array.from(fmt);
    for (let i = 0; i < fmtLen; i++) {
        if (fmtChars[i] === escape) {
            const nextChar = fmtChars[i + 1];
            if (nextChar && (nextChar === escape || nextChar in km)) {
                rest.push(nextChar);
                fmtChars[i] = escapeReplacement[0];
                fmtChars[i + 1] = escapeReplacement[1];
                i++;
            }
        }
    }
    const finalChars = new Array(fmtLen);
    for (let i = fmtLen - 1; i >= 0; i--) {
        const fmtChar = fmtChars[i];
        finalChars[i] = (_b = (_a = km[fmtChar]) === null || _a === void 0 ? void 0 : _a.pop()) !== null && _b !== void 0 ? _b : fmtChar;
    }
    let restIndex = 0;
    const output = new Array(fmtLen);
    for (let i = 0; i < fmtLen; i++) {
        if (finalChars[i] === escape && finalChars[i + 1] === escape) {
            output[i] = rest[restIndex];
            restIndex++;
            i++;
        }
        else {
            output[i] = finalChars[i];
        }
    }
    return output.join("");
}
//# sourceMappingURL=format.js.map